export default __webpack_public_path__ + "static/media/menu.289488d4.svg";